import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import "./assets/locale/i18n";
import { PersistGate } from "redux-persist/integration/react";
import Loader from "./components/Loader/Loader";

ReactDOM.render(
    <Provider store={store}>
        <PersistGate 
            loading={<Loader type="TailSpin" />} 
            persistor={persistor} 
            // onBeforeLift={() => new Promise((resolve) => setTimeout(resolve, 1000))}
        >
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
